
import { useEffect, useState } from "react";

interface Petal {
  id: number;
  x: number;
  y: number;
  rotation: number;
  speed: number;
  delay: number;
  image: string;
}

const petalImages = [
  "/lovable-uploads/fab03d61-9ac9-4196-b088-b03c686cfc14.png",
  "/lovable-uploads/dc8f1394-4bab-45f8-95d7-30be886837a8.png",
  "/lovable-uploads/82dd1666-6248-4aa0-b49d-06b8506af1a2.png",
  "/lovable-uploads/6b7a32aa-6791-41a1-91ce-e5e188cda71a.png",
  "/lovable-uploads/c8416286-8f21-4882-8692-995acd7e22dd.png",
  "/lovable-uploads/1947d979-1aaa-4f87-ae9a-647666a2ff85.png",
];

export const SakuraPetals = () => {
  const [petals, setPetals] = useState<Petal[]>([]);

  useEffect(() => {
    const createPetal = (id: number) => ({
      id,
      x: Math.random() * 100,
      y: -20,
      rotation: Math.random() * 360,
      speed: 1 + Math.random() * 2,
      delay: Math.random() * 10,
      image: petalImages[Math.floor(Math.random() * petalImages.length)],
    });

    const initialPetals = Array.from({ length: 20 }, (_, i) => createPetal(i));
    setPetals(initialPetals);

    const animationInterval = setInterval(() => {
      setPetals((currentPetals) =>
        currentPetals.map((petal) => {
          if (petal.delay > 0) {
            return { ...petal, delay: petal.delay - 0.1 };
          }

          const newY = petal.y + petal.speed;
          const newX = petal.x - petal.speed * 0.5;
          const newRotation = petal.rotation + petal.speed * 2;

          if (newY > 120 || newX < -20) {
            return createPetal(petal.id);
          }

          return {
            ...petal,
            y: newY,
            x: newX,
            rotation: newRotation,
          };
        })
      );
    }, 50);

    return () => clearInterval(animationInterval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {petals.map((petal) => (
        <img
          key={petal.id}
          src={petal.image}
          alt="sakura petal"
          className="absolute w-8 h-8"
          style={{
            top: `${petal.y}%`,
            left: `${petal.x}%`,
            transform: `rotate(${petal.rotation}deg)`,
            opacity: petal.delay > 0 ? 0 : 0.6,
            transition: "opacity 0.5s ease-in-out",
          }}
        />
      ))}
    </div>
  );
};
